<template>
  <v-app id="mady" class="app_box">
    <v-main :class="$route.meta.from == 'user' ? 'user_box' : 'course_box'">
      <Navbar v-if="$route.meta.from != 'user'"></Navbar>
      <v-container id="mady_info" class="custom-container" grid-list-md text-xs-center fluid>
        <Bread></Bread>
        <router-view></router-view>
      </v-container>
    </v-main>
    <!-- <Footer v-show="!$route.meta.page || $route.meta.page == 'login'"></Footer> -->
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
// import Footer from './components/common/Footer.vue'
import Navbar from './components/common/Navbar.vue'
import { getCookie } from '@/libs/cookie.js'
import { SendState, CheckLogin, GetQueryString } from '@/libs/util'
import Bread from './components/common/Bread.vue'
import { connectUserWebSocket } from '@/libs/userws'
import { getUserBasicInfo } from '@/libs/util'
export default {
  components: {
    // Footer,
    Navbar,
    Bread
  },
  data: () => ({
    serverTime: ''
  }),
  computed: mapGetters({
    menu: 'getMenu',
    menuActive: 'getMenuActive',
    courseActive: 'getCourseActive',
    indexActive: 'getIndexActive',
    course: 'getCourse',
    partList: 'getPartList',
    group: 'getGroup',
    bread: 'getBread',
    credential: 'getCredential'
  }),

  created() {
    SendState({
      page: 'createApp'
    })
    // 调用util中 验证登录方法
    if (!CheckLogin()) {
      if (GetQueryString('code')) {
        if (GetQueryString('appid')) {
          this.$router.replace({ path: '/work' })
        } else {
          this.$router.replace({ path: '/wx' })
        }
      } else {
        this.$router.replace({ path: '/login' })
      }
    }
    this.setDefinition(getCookie('playerDefinition') || 'SD')
  },
  mounted() {
    connectUserWebSocket(getUserBasicInfo('id'))
  },
  beforeDestroy() {
    SendState({
      page: 'destroyApp'
    })
  },
  methods: {
    ...mapActions(['setDefinition'])
  }
}
</script>
<style>
#mady {
  background-color: #f9f9f9;
}
.custom-container {
  height: calc(100%);
  overflow-y: auto;
}
</style>
